<template>
    <section class="combo-cart" :class="{ 'mobile-style' : !isDesktop, 'modal-wrapper': context != 'PDPDESKTOP', 'is-black-rabbit' : isBlackRabbit }">
        <div class="modal-container">
            <div v-if="canShowRegularHeader" class="modal-header">
                <p class="header-title"> {{ comboKStrings.kCHOOSE_YOUR_PRODUCTS_OPTIONS }} </p>
                <i class="ecom-close prz-close" @click="close"/>
            </div>
            <Header v-if="canShowNewHeader" class="light-filter">
                <template v-slot:first>
                    <div class="header-item big-container order-0">
                        <p class="header-title"> {{ comboKStrings.kCHOOSE_YOUR_PRODUCTS_OPTIONS }} </p>
                    </div>
                </template>
                <template v-slot:second>
                    <div class="d-none"/>
                </template>
                <template v-slot:third>
                    <div class="header-item small-container order-3" @click="close">
                        <i class="reduced prz-close"/>
                    </div>
                </template>
            </Header>
            <div class="modal-body" :class="[ isDesktop ? 'row' : '' ]">
                <div class="combo-item-container" :class="{ 'col' : isDesktop, 'is-ready' : wsOneReady }">
                    <QuickCart
                        v-if="firstProductData"
                        :key="firstProductData.groupId"
                        :group-id="firstProductData.groupId" 
                        :combo-cart-mode="true"
                        :combo-id="comboId"
                        :web-event-value="webEventValue"
                        :preLoadedProductData="firstProductData.data"
                        @loadComplete="loadComplete"
                        :class="{ 'mobile-style' : !isDesktop }"
                        @ws-ok="wsOneReady = true"
                        @has-carousel="firstHasCarousel = true"
                    />
                </div>
                <i v-if="wsOneReady" class="combo-icon ecom-plus prz-plus" :class="{'centered' : isDesktop && centerPlusIcon}"/>
                <div class="combo-item-container" :class="{ 'col' : isDesktop, 'is-ready' : wsTwoReady }">
                    <QuickCart
                        v-if="secondProductData"
                        :key="secondProductData.groupId"
                        :group-id="secondProductData.groupId"
                        :combo-cart-mode="true"
                        :combo-id="comboId"
                        :web-event-value="webEventValue"
                        :preLoadedProductData="secondProductData.data"
                        @loadComplete="loadComplete"
                        :class="{ 'mobile-style' : !isDesktop }"
                        @ws-ok="wsTwoReady = true"
                        @has-carousel="secondHasCarousel = true"
                    />
                </div>
                <single v-if="isBlackRabbit && (!isLoading && couponId)" :item="blackRabbitCoupon" :margins="true" />
                <div v-if="!isBlackRabbit && !isDesktop && couponId" class="row mx-0 coupon-container">
                    <span class="coupon-info col p-0"> {{ comboKStrings.kUSE_CODE_DURING_CHECKOUT }} </span>
                    <CopyToClipboard :coupon-text="true" :value="couponId" :k-strings="comboKStrings" @input="clickCopyCoupon" />
                </div>
            </div>
            <div class="modal-footer mx-0" :class="{ 'row' : isDesktop }">
                <div v-if="price" class="price-combo-container p-0" :class="[ !isDesktop ? 'col' : 'col-auto' ]">
                    <span v-show="isBlackRabbit" class="total-desc"> {{ comboKStrings.kGLOB_TOTAL + ':' }} </span>
                    <p v-if="priceCrossed" class="price crossed"> {{ priceCrossed }} </p>
                    <p class="price"> {{ price }} </p>
                </div>
                <div v-if="!isBlackRabbit && isDesktop && couponId" class="coupon-container col">
                    <span class="coupon-info"> {{ comboKStrings.kUSE_CODE_DURING_CHECKOUT }} </span>
                    <CopyToClipboard :coupon-text="true" :value="couponId" :k-strings="comboKStrings" @input="clickCopyCoupon" />
                </div>
                <div class="buttons-container col-auto p-0">
                    <button v-if="isDesktop" class="button-white" @click="close" data-mub-skip="y"> {{ comboKStrings.kCANCEL }} </button>
                    <Mub :rawData="mubRawData">
                        <button class="button-red" :class="{ 'cart-warning' : cartWarning }" :disabled="!canAddCombo || cartWarning" @click="addComboToCart"> 
                            <i v-if="cartWarning" class="ecom-info"/>
                            {{ !cartWarning ? comboKStrings.kBUY_NOW : cartWarning}} 
                        </button>
                    </Mub>
                </div>
            </div>
            <MuffinLoader v-if="isLoading" :class="{ 'full-page' : !isDesktop}"/>
        </div>
    </section>
</template>

<script>

import QuickCart from "@/components/ComboCart/QuickCart.vue";
import MuffinLoader from '@/components/Muffin/Loader';
import Mub from '@/components/Mub';
import CopyToClipboard from '@/components/Muffin/CopyToClipboard';
import homeUtils from '@/Utilities/homeUtils';

import apiCart from '@/api/cart';
import {storeCombos} from '@/store/comboCart';
import {storeHeader} from '@/store/mobileNavigation/header';
import websiteEvents from '@/Utilities/website-events';
import appProzis from '@/Utilities/app-prozis-store';

import Single from '@/components/Blocks/Block/Single.vue';
import { BlockPromo } from '@/models/Blocks/Itens/block-promo';
//import { BlockItemContent } from '@/models/Blocks/Itens/Types/block-content-types';
import { TemplateItemType } from '@/models/Blocks/Itens/Types/template-item-type';

export default {
    store: storeCombos,
    name: 'ComboCart',
    components: {
        //Only for mobile and BlackRabbit theme
        Header: () => import('@/components/MobileNavigation/Header.vue'),
        QuickCart,
        MuffinLoader,
        CopyToClipboard,
        Mub,
        Single
    },
    props: {
        isDesktop: {type: Boolean, default: true},
        webEventValue: {type: String, default: ''},
        couponId: {type: String, default: null},
        comboId: {type: String, default: null},
        showHeader: {type: Boolean, default: true},
        promoContent: {type: Object, default: undefined},
        blocksColor: {type: String, default: ''},
        context: {type: String, default: ''},
        mubData: {type: String, default: null},
        comboData: {type: Object, default: undefined},
    },
    data() {
        return {
            // testing
            wsOneReady: false,
            wsTwoReady: false,
            // just to center icon plus, maybe use store and set by type?
            firstHasCarousel: false,
            secondHasCarousel: false,
            productsLoaded: 0,
            //
        };
    },
    watch:{
        productsLoaded: {
            handler(newValue){
                if(newValue>=2){
                    this.$nextTick(() => {
                        this.$emit('loadComplete');
                    });
                }
            },
            immediate: true
        }
    },
    computed: {
        isLoading() {
            return storeCombos.getters.isLoading || (!this.wsOneReady || !this.wsTwoReady);
        },
        comboKStrings() {
            return storeCombos.getters.comboKStrings;
        },
        price() {
            const data = storeCombos.getters.priceData;
            return data && data[this.comboId] ? data[this.comboId].price : null;
        },
        priceCrossed() {
            const data = storeCombos.getters.priceData;
            return data && data[this.comboId] ? data[this.comboId].priceCrossed : null;
        },
        /*couponId() {
            return storeCombos.getters.couponId;
        },*/
        firstProductData() {
            const data = storeCombos.getters.productsData;
            return data && data[this.comboId] ? data[this.comboId][0] : null;
        },
        secondProductData() {
            const data = storeCombos.getters.productsData;
            return data && data[this.comboId] ? data[this.comboId][1] : null;
        },
        skuList() {
            return storeCombos.getters.skuList;
        },
        // in test 
        canAddCombo() {
            let wsLoaded = this.firstProductData && this.secondProductData;
            let skusLoaded = wsLoaded && Object.keys(this.skuList).length >= 2;
            
            return wsLoaded && skusLoaded;
        },
        centerPlusIcon() {
            // criteria: only when both products have carousel selection types
            return this.firstHasCarousel && this.secondHasCarousel;
        },
        cartWarning() {
            return this.isDesktop ? storeCombos.getters.cartWarning : null;
        },
        mubRawData(){
            let mub = null;
            if(this.mubData){
                mub = JSON.parse(this.mubData);
            }
            else{
                const data = storeCombos.getters.mubData;
                mub = data && data[this.comboId] ? data[this.comboId] : null;
            }
            if(mub){
                // force "no observer"
                mub['obs'] = false;
                // force target as "add to cart"
                mub['ta'] = 'a2c';
            }
            return mub;
        },
        isBlackRabbit() {
            return storeCombos.getters.isBlackRabbit;
        },
        blackRabbitCoupon() {
            const context  = this.promoContent?.context ?? 'PDP';
            const label    = context == 'HOME' || context == 'MAGICCART' ?
                            this.promoContent?.label ?? undefined :
                            {text: this.comboKStrings.kBUNDLE_OFFER , color: '#fff'};
            const title    = context == 'HOME' || context == 'MAGICCART' ?
                            this.promoContent?.title ?? undefined : 
                            {text: homeUtils.removeClass(this.promoContent?.label ?? this.comboData?.label ?? ''), color: '#6F6F6F'};
            const subtitle = {text: this.comboKStrings.kUSE_COUPON_CODE, color: (this.promoContent?.subtitle?.color ?? '#fff')};
            const bgColor  = this.blocksColor ? this.blocksColor : (this.promoContent?.backgroundColor ?? '#FFBB69');
            const coupon   = this.promoContent?.coupon ?? {text: this.couponId ?? 'MYPACK', copied: this.comboKStrings.kCOPIED, background: bgColor, color: '#FFF'};
            
            let promo      = new BlockPromo(title, coupon, subtitle, label);
            promo.templateType    = TemplateItemType.horizontal;
            promo.backgroundColor = bgColor;

            return promo;
        },
        canShowRegularHeader(){
            return this.showHeader && (!this.isBlackRabbit || this.context == 'BLOCKDESKTOP');
        },
        canShowNewHeader(){
            // console.log('this.showHeader', this.showHeader);
            // console.log('storeCombos.getters.isBlackRabbit', storeCombos.getters.isBlackRabbit)
            // console.log('storeCombos.getters.isAppMode', storeCombos.getters.isAppMode)
            //console.log('webEventValue', this.webEventValue)

            return this.showHeader && !this.isDesktop && this.isBlackRabbit;
            //return this.showHeader && storeCombos.getters.isBlackRabbit && !storeCombos.getters.isAppMode;
        },
    },
    // watch: {},
    // created() {},
    mounted() {
        this.$nextTick(function() {
            storeCombos.dispatch('setSkuList', {}); // reset skulist
        });
        websiteEvents.eventCombo('open', this.webEventValue, {coupon: this.couponId});
    },
    methods: {
        loadComplete(){
            this.productsLoaded++;
        },
        close() {
            this.$emit('close');
            websiteEvents.eventCombo('close', this.webEventValue, {coupon: this.couponId});
        },
        async addComboToCart() { // add unit tests
            try {
                // copy "input" text/value
                storeCombos.dispatch('setLoading', true);
                // convert to STORE?
                if (this.canAddCombo) {
                    let skus = Object.values(this.skuList);
                    let items = [];
                    skus.forEach((sku, index) => {
                        // addQty: add quantity if product already exists in cart 
                        items.push({sku: sku, quantity: 1, type: 0, addQty: true});
                    });
                    const {data} = await apiCart.addToCartBulk(items, 0);
//                    console.log(response);
                    let hasError = !data || !data.hasOwnProperty('error') || data.error;
                    //console.log('has error: ', hasError);
                    storeCombos.dispatch('setLoading', false);
                    
                    if(!hasError) {
                        storeCombos.dispatch('setComboModal', {[this.comboId]: false });
                        //console.log('last cart response: ', response);
                        let numCartItems = data.cart.itemCount;
                        
                        if(numCartItems) {
                            if(this.isDesktop) {
                                VueEs6.addToCartDesktop.cartItemNumUpdate(numCartItems);
                                VueEs6.header.miniCart.updateAndOpen(false);
                                websiteEvents.eventCombo('added', this.webEventValue, {coupon: this.couponId});
                                this.close();
                            } else {
                                //VueEs6.addToCart.cartItemNumUpdate(numCartItems);
                                //storeCombos.dispatch('cartItemNumUpdate', numCartItems);
                 
                                let responseError = data.error;
                                const success = !responseError ? true : false;
                                const message = !responseError ? this.comboKStrings.kCART_COMBO_SUCCESS : this.comboKStrings.kSOMETHING_WRONG;
                                const actionText = !responseError ? this.comboKStrings.kVIEW_CART : '';

                                if(this.isBlackRabbit) {
                                    websiteEvents.eventCombo((success ? 'added' : 'not-added'), this.webEventValue, {coupon: this.couponId});
                                    this.updateCartQtyWithAnim(numCartItems, message);
                                    this.close();
                                } else {
                                    storeCombos.dispatch('cartItemNumUpdate', numCartItems);
                                    this.afterRequest(success, message, actionText);
                                }
                            }
                        }
                    } else {
                        //console.log('can\'t add combo, cart error...');
                        //let cartMsgError = data.hasOwnProperty('message') ? data.message : this.comboKStrings.kSOMETHING_WRONG;
                        //console.log('CART MSG ERROR: ', cartMsgError);
                        if(this.isBlackRabbit) {
                            this.updateCartQtyWithAnim();
                            this.afterRequest(false, '', '');
                        } else {
                            let cartMsgError = data.hasOwnProperty('message') ? data.message : this.comboKStrings.kSOMETHING_WRONG;
                            this.afterRequest(false, cartMsgError, '');
                        }
                        
                        
                    }
                } else {
                    if(this.isBlackRabbit) {
                        this.updateCartQtyWithAnim();
                    }
                    this.afterRequest(false, this.comboKStrings.kSOMETHING_WRONG, '');
                }

            } catch (error) {
                //console.log('widget has errors, please try another time :(', error);
                storeCombos.dispatch('setLoading', false);
                this.afterRequest(false, this.comboKStrings.kSOMETHING_WRONG, '');
            }
        },
        updateCartQtyWithAnim(qty = 0, msg = null){
            if(this.isBlackRabbit){
                let message = msg ? msg : this.kStrings.kSOMETHING_WRONG;
                storeHeader.dispatch('updateCartQtyWithAnim', {qty: qty, msg: message});
                this.$emit('updateCartQtyWithAnim', {qty: qty, msg: message});
            }
        },
        afterRequest(success, message, actionText){
            // register event before closing modal 
            websiteEvents.eventCombo((success ? 'added' : 'not-added'), this.webEventValue, {coupon: this.couponId});
            if(this.isDesktop) {
                storeCombos.dispatch('setCartWarning', this.comboKStrings.kSOMETHING_WRONG);
            } else {
                if(!this.isBlackRabbit){
                    const cartNotificationData = {
                        link: '',
                        success: success,
                        animationState: null,
                        message: message,
                        actionText: actionText,
                    };
                    storeCombos.commit('updateCartNotification', cartNotificationData);
                    storeCombos.dispatch('setComboModal', {[this.comboId]: false });
                }
            }
            
            if(success && !this.showHeader){
                //console.log('ComboCart afterRequest -> call App.js.callAppsJs evtNativeModalClose');
                //App.js.callAppsJs('evtNativeModalClose', true);
                appProzis.call('goBack', true);
            }
        },

        clickCopyCoupon() {
            websiteEvents.eventCombo('copy', this.webEventValue, {coupon: this.couponId});
        },

    },
};
</script>

<style lang="scss">

</style>
